// Libs
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { Collapse, Icon, Divider, Tooltip } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
    getAllFiscaisOptions,
    getAllTenicoMedicaoOptions,
    getAllUsuarios,
    Usuario,
    getAllFornecedoresWithNumberContratoOptions,
} from '@app/api/usuario';

//Files

//Utils
import { hasPermission } from '@app/helpers/permissions';
import { getContratoMultiplosGestores, putContratoMultiplosGestoresFornecedores } from '@app/api/contrato';
import { mapToOptions } from '@app/helpers/arrayHelper';
import { isObjEmpty } from '@app/helpers/objHelper';
import { getAllPlanilhaQuantidadeMultiplosGestoresByContrato } from '@app/api/contrato/planilhaQuantidadeContrato';
import { AbaInformacaoComplementar, getInformacaoComplementarById, updateResponsaveisFornecedorContrato } from '@app/api/contrato/informacaoComplementar';
import ModalCriarUsuarioFornecedor from './ModalCriarUsuarioFornecedor';
import { Button, Col, Row } from '@digital/ui';
import { Space } from '@app/components';

const { Panel } = Collapse;

interface PanelResponsaveisMrnV2Props {
    contratoId: string;
    isConsolidado?: boolean;
}

export interface FormResponsaveisMrn {
    planilhaDeQuantidadeId: string;
    planilhaDeQuantidadeNome: string;
    gestorId: string;
    fiscalId: string;
    fiscalAlternativoId: string;
    tecnicoMedicaoId: string;
    administradorContratoId: string;
    administradorContratoAlternativoId: string;
    dataValidaInicio: string;
    dataValidaFinal: string;
    responsavelRateioId: string;
    contratoLegivelParaProcessoNda: string;
    diretoriaId: string;
    possuiArea: boolean;
    possuiDepartamento: boolean;
    areaId: string;
    departamentoId: string;
    responsavelFornecedorEmail: string;
    responsavelFornecedorNome: string;
    responsavelFornecedorEmailFinanceiro: string;
    fornecedorGestorId: string;
    fornecedorFiscalId: string;
    fornecedorFinanceiroId: string;
    responsavelTacId: string;
}

export function PanelResponsaveisFornecedorV2({
    contratoId,
    isConsolidado
}: PanelResponsaveisMrnV2Props) {

    const [initialValues, setInitialValues] = useState({} as FormResponsaveisMrn);
    const [planilhasQuantidade, setPlanilhasQuantidade] = useState<any[]>();

    const [fiscalOptions] = ui.usePromise(getAllFiscaisOptions, [], [] as ui.OptionProps[]);
    const [tecnicoOptions] = ui.usePromise(getAllTenicoMedicaoOptions, [], [] as ui.OptionProps[]);

    const [update, setUpdate] = useState(false);
    const [modalCriarUsuarioFornecedor, setModalCriarUsuarioFornecedor] = useState(false);

    const { selectedItem } = useContext(ui.CrudContext);
    // new
    const [hasResponsavelTac, setHasResponsavelTac] = useState(true);
    const [infoComplementarData] = ui.usePromise(
        () => {
            return selectedItem ? getInformacaoComplementarById(selectedItem.id) : Promise.resolve(undefined);
        },
        [selectedItem],
        {} as AbaInformacaoComplementar,
    );

    const submitResponsaveisFornecedor = (values: any) => updateResponsaveisFornecedorContrato(values);
    //
    const onUpdate = () => { setUpdate(!update) }

    function getNome(u: Usuario | undefined) { return u && (u.nome || u.email) ? (u.nome || u.email) : ''; }
    function getEmail(u: Usuario | undefined) { return u && u.email ? u.email : ''; }
    function toDate(v: string | Date | undefined) { return v ? new Date(v) : undefined; }
    const [userById, setUserById] = useState<Map<string, Usuario>>(new Map());

    function buildInitialValuesFromPQ(pq: FormResponsaveisMrn, map?: Map<string, Usuario>) {
        var gestor = map && map.get(pq.fornecedorGestorId);
        var fiscal = map && map.get(pq.fornecedorFiscalId);
        var financeiro = map && map.get(pq.fornecedorFinanceiroId);
        var tac = pq.responsavelTacId ? map && map.get(pq.responsavelTacId) : undefined;

        return Object.assign({}, pq, {
            planilhaDeQuantidadeId: pq.planilhaDeQuantidadeId,
            responsavelFornecedorNome: pq.responsavelFornecedorNome,
            responsavelFornecedorEmail: pq.responsavelFornecedorEmail,

            responsavelFornecedorEmailFinanceiro: pq.responsavelFornecedorEmailFinanceiro,

            informacaoComplementar_FornecedorGestorNome: getNome(gestor),
            informacaoComplementar_FornecedorGestorEmail: getEmail(gestor),
            informacaoComplementar_FornecedorGestorUltimoAcesso: toDate(gestor && gestor.dataHoraUltimaAcesso),

            informacaoComplementar_NomeFiscal: getNome(fiscal),
            informacaoComplementar_FornecedorEmailFiscal: getEmail(fiscal),
            informacaoComplementar_UltimoAcessoFiscal: toDate(fiscal && fiscal.dataHoraUltimaAcesso),

            informacaoComplementar_NomeFinanceiro: getNome(financeiro),
            informacaoComplementar_FornecedorEmailFinanceiro: getEmail(financeiro),
            informacaoComplementar_UltimoAcessoFinanceiro: toDate(financeiro && financeiro.dataHoraUltimaAcesso),

            informacaoComplementar_ResponsavelTac: getNome(tac),
            informacaoComplementar_EmailResponsavelTac: getEmail(tac),
            informacaoComplementar_UltimoAcessoResponsavelTac: toDate(tac && tac.dataHoraUltimaAcesso),
        });
    }

    const onSubmitForm = (values: any) => {
        putContratoMultiplosGestoresFornecedores(contratoId, values)
            .then(data => {
                onUpdate();
            })
    }

    useEffect(function () {
        var mounted = true;

        (async function () {
            try {
                var multGestoresResp = await getContratoMultiplosGestores(contratoId);
                if (!mounted) return;

                var pqs = multGestoresResp && multGestoresResp.dados ? multGestoresResp.dados : [];

                if (!hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'])) {
                    var result = await getAllPlanilhaQuantidadeMultiplosGestoresByContrato(contratoId);
                    pqs = pqs.filter(function (item) {
                        var aux = result && result.find ? result.find(function (r) { return r.id === item.planilhaDeQuantidadeId; }) : null;
                        return !!(aux && aux.isResponsavel);
                    });
                }

                setPlanilhasQuantidade(pqs);
                if (!pqs || pqs.length === 0) return;

                var idsSet = new Set<string>();
                pqs.forEach(function (p) {
                    if (p.fornecedorGestorId) idsSet.add(p.fornecedorGestorId);
                    if (p.fornecedorFiscalId) idsSet.add(p.fornecedorFiscalId);
                    if (p.fornecedorFinanceiroId) idsSet.add(p.fornecedorFinanceiroId);
                    if (p.responsavelTacId) idsSet.add(p.responsavelTacId);
                });

                var usuarios = await getAllUsuarios();
                if (!mounted) return;
                usuarios = usuarios || [];

                var pares = usuarios
                    .filter(function (u) { return u && u.id && idsSet.has(u.id); })
                    .map(function (u) { return [u.id, u] as [string, Usuario]; });

                var mapFiltrado = new Map<string, Usuario>(pares);
                setUserById(mapFiltrado);

                var pqDefault = pqs.reduce(function (prev, current) {
                    var prevNum = Number(String(prev.planilhaDeQuantidadeNome).replace(/\D/g, ''));
                    var curNum = Number(String(current.planilhaDeQuantidadeNome).replace(/\D/g, ''));
                    return prevNum < curNum ? prev : current;
                });

                var pqSelecionada = null;
                if (initialValues && !isObjEmpty(initialValues)) {
                    pqSelecionada = pqs.find(function (p) {
                        return p.planilhaDeQuantidadeId === initialValues.planilhaDeQuantidadeId;
                    }) || null;
                }
                if (!pqSelecionada) pqSelecionada = pqDefault;
                if (!pqSelecionada) return;
                setInitialValues(buildInitialValuesFromPQ(pqSelecionada, mapFiltrado))
            } catch (e) {
                console.error(e);
            }
        })();

        return function () { mounted = false; };
    }, [contratoId, update, isConsolidado]);

    var memoForm = useMemo(() => {

        return (
            <ui.MasterDetailForm
                onSubmit={onSubmitForm}
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                    responsavelFornecedorNome: Yup.string()
                        .required('Responsável deve ser informada')
                        .max(200, 'O nome do responsável deve ter no máximo 200 caracteres.'),
                    responsavelFornecedorEmail: Yup.string()
                        .required('E-mail do Responsável deve ser informado')
                        .email('Deve ser informado um endereço de e-mail válido')
                        .max(200, 'O E-mail do Responsável deve ter no máximo 200 caracteres.'),
                    responsavelFornecedorEmailFinanceiro: Yup.string()
                        .required('E-mail do Responsável Financeiro deve ser informado')
                        .email('Deve ser informado um endereço de e-mail válido')
                        .max(200, 'O E-mail do Responsável Financeiro deve ter no máximo 200 caracteres.'),
                })}>
                <ui.Widget
                    actions={[
                        hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                            <ui.FormSubmitButton noIcon type="primary">
                                <ui.FormatText id="ui.commons.save" uppercase />
                            </ui.FormSubmitButton>
                        ),
                    ]}>
                    <Row
                        justify="space-between"
                        align="middle"
                        style={{ width: '100%' }}
                    >
                        <Col span={10}>
                            <ui.FormSelect
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, item: any) => {
                                    return item.props.children.props.id
                                        .toString()
                                        .toLowerCase()
                                        .startsWith(input.toLowerCase());
                                }}
                                label="Planilha de Quantidade"
                                name="planilhaDeQuantidadeId"
                                placeholder="Selecione uma opção"
                                options={mapToOptions(
                                    planilhasQuantidade,
                                    'planilhaDeQuantidadeId',
                                    'planilhaDeQuantidadeNome'
                                )}
                                span={4}
                                allowClear
                                onSelect={(value: any) => {
                                    if (!planilhasQuantidade) return;
                                    const pq = planilhasQuantidade.find(
                                        f => f.planilhaDeQuantidadeId == value
                                    );
                                    if (!pq) return;

                                    setInitialValues(buildInitialValuesFromPQ(pq, userById));
                                }}
                            />
                        </Col>

                        <Col
                            span={2}
                        >
                            <Tooltip title="Adicionar Novo Usuário Fornecedor">
                                <Button
                                    key="editItem"
                                    icon="ui-add"
                                    onClick={() => {
                                        setModalCriarUsuarioFornecedor(true);
                                    }}
                                >
                                    Usuário Fornecedor
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>

                    <Divider />

                    <ui.FormInput label="Responsável" name="responsavelFornecedorNome" span={4} />
                    <ui.FormInput label="E-mail do Responsável" name="responsavelFornecedorEmail" span={4} />

                    <ui.FormInput
                        label="E-mail do Responsável Financeiro"
                        name="responsavelFornecedorEmailFinanceiro"
                        span={4}
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Gestor"
                        name="fornecedorGestorId"
                        placeholder="Selecione uma opção"
                        required
                        getOptions={getAllFornecedoresWithNumberContratoOptions}
                        span={4}
                    />
                    <ui.FormInput
                        label="E-mail do Gestor"
                        name="informacaoComplementar_FornecedorGestorEmail"
                        span={4}
                        disabled
                    />
                    <ui.FormDatePicker
                        format="DD/MM/YYYY"
                        label="Último acesso do Gestor"
                        name="informacaoComplementar_FornecedorGestorUltimoAcesso"
                        span={4}
                        disabled
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Fiscal"
                        name="fornecedorFiscalId"
                        placeholder="Selecione uma opção"
                        required
                        getOptions={getAllFornecedoresWithNumberContratoOptions}
                        span={4}
                    />
                    <ui.FormInput
                        label="E-mail do Fiscal"
                        name="informacaoComplementar_FornecedorEmailFiscal"
                        span={4}
                        disabled
                    />
                    <ui.FormDatePicker
                        format="DD/MM/YYYY"
                        label="Último acesso do Fiscal"
                        name="informacaoComplementar_UltimoAcessoFiscal"
                        span={4}
                        disabled
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Financeiro"
                        name="fornecedorFinanceiroId"
                        placeholder="Selecione uma opção"
                        required
                        getOptions={getAllFornecedoresWithNumberContratoOptions}
                        span={4}
                    />
                    <ui.FormInput
                        label="E-mail do Financeiro"
                        name="informacaoComplementar_FornecedorEmailFinanceiro"
                        span={4}
                        disabled
                    />
                    <ui.FormDatePicker
                        format="DD/MM/YYYY"
                        label="Último acesso do Financeiro"
                        name="informacaoComplementar_UltimoAcessoFinanceiro"
                        span={4}
                        disabled
                    />
                    {
                        hasResponsavelTac && (
                            <>
                                <ui.FormInput label="Responsável TAC" name="informacaoComplementar_ResponsavelTac" span={4} disabled />
                                <ui.FormInput
                                    label="E-mail do Responsável TAC"
                                    name="informacaoComplementar_EmailResponsavelTac"
                                    span={4}
                                    disabled
                                />
                                <ui.FormDatePicker
                                    format="DD/MM/YYYY"
                                    label="Último acesso do Responsável TAC"
                                    name="informacaoComplementar_UltimoAcessoResponsavelTac"
                                    span={4}
                                    disabled
                                />
                            </>
                        )
                    }
                </ui.Widget>
            </ui.MasterDetailForm>
        );
    }, [initialValues])

    return (
        <>
            <ModalCriarUsuarioFornecedor
                contratoId={contratoId}
                PlanilhaDeQuantidadeId={initialValues.planilhaDeQuantidadeId}
                exibirModal={modalCriarUsuarioFornecedor}
                setExibirModal={setModalCriarUsuarioFornecedor}
                onUpdate={onUpdate}
            />
            <Collapse
                bordered={false}
                expandIcon={() => <Icon type="arrows-right_4" />}
                defaultActiveKey={'responsaveisMRN'}
            >
                <Panel key="responsaveisMRN" header={<span>Responsáveis Fornecedor</span>} style={{ border: 0 }}>
                    {memoForm}
                </Panel>
            </Collapse>
        </>
    )
}